export const TOTAL_SCORE_DASHBOARD_ROW = {
  pin: "Total_Score",
  name: "Total_Score",
  title: "Total Score",
  show: false,
};

export const hasDashboardValue = (value) =>
  value !== null && value !== undefined && value !== "";

export const buildDashboardCardRows = (cardsForTable, cardsStatus) => {
  if (!Array.isArray(cardsForTable) && !cardsStatus) {
    return [];
  }

  const rows = Array.isArray(cardsForTable) ? [...cardsForTable] : [];
  const totalScoreRowIndex = rows.findIndex(
    (row) => row?.name === "Total_Score" || row?.title === "Total Score"
  );

  if (totalScoreRowIndex === -1) {
    rows.push({
      ...TOTAL_SCORE_DASHBOARD_ROW,
      show: Boolean(cardsStatus?.Total_Score),
    });
    return rows;
  }

  if (hasDashboardValue(cardsStatus?.Total_Score)) {
    rows[totalScoreRowIndex] = {
      ...rows[totalScoreRowIndex],
      show: Boolean(cardsStatus.Total_Score),
    };
  }

  return rows;
};

export const getDashboardTotalScoreValue = (totalFeedbacks) =>
  hasDashboardValue(totalFeedbacks?.total_score) ? totalFeedbacks.total_score : 0;

// Module 3 — Question-wise Rating card summary stats

export const getWeightedFeedbackSummary = (weightedAvgData) => {
  if (!Array.isArray(weightedAvgData) || weightedAvgData.length === 0) {
    return null;
  }

  const scored = weightedAvgData.filter((item) => hasDashboardValue(item?.avg_score));
  if (scored.length === 0) {
    return null;
  }

  const total = scored.reduce((sum, item) => sum + Number(item.avg_score), 0);
  const average = total / scored.length;

  const highest = scored.reduce((max, item) =>
    Number(item.avg_score) > Number(max.avg_score) ? item : max
  );
  const lowest = scored.reduce((min, item) =>
    Number(item.avg_score) < Number(min.avg_score) ? item : min
  );

  return {
    average: average.toFixed(2),
    highestIndex: highest.index,
    lowestIndex: lowest.index,
  };
};
